export interface WheelLabelText {
  text: string;
  size: number;
  offsetY: number;
}

export interface WheelSlice {
  fill: string;
  border: {
    color: string | null;
    width: number;
    style: string;
  };
  label: {
    main: WheelLabelText;
    sub: WheelLabelText;
  };
}

export interface WheelConfig {
  version?: string;
  size: {
    radius: number;
    borderWidth: number;
    // 相对画布中心的偏移，单位 px，>0 向右/向下，<0 向左/向上
    centerOffsetX?: number;
    centerOffsetY?: number;
  };
  colors: {
    border: string;
    text: string;
    backgrounds: string[];
  };
  text: {
    fontFamily: string;
  };
  slices: WheelSlice[];
}

export const POP_WHEEL_CONFIG: Record<string, WheelConfig> = {
  '188': {
    version: '1.0.0',
    size: {
      radius: 360,
      borderWidth: 19,
      centerOffsetX: 0,
      centerOffsetY: 0,
    },
    colors: {
      border: '#ABB161',
      text: '#484B2B',
      backgrounds: ['#FFF8BC', '#FFFFFF']
    },
    text: {
      fontFamily: 'Georgia, serif'
    },
    slices: [
      {
        fill: '#FFF8BC',
        border: {
          color: '#FFF8BC',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '50%',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'OFF',
            size: 30,
            offsetY: 210
          }
        }
      },
      {
        fill: '#FFFFFF',
        border: {
          color: '#FFFFFF',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: 'FREE',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'SHIPPING',
            size: 30,
            offsetY: 210
          }
        }
      },
      {
        fill: '#FFF8BC',
        border: {
          color: '#FFF8BC',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '10%',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'OFF',
            size: 30,
            offsetY: 210
          }
        }
      },
      {
        fill: '#FFFFFF',
        border: {
          color: '#FFFFFF',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: 'ALMOST',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'WIN',
            size: 30,
            offsetY: 210
          }
        }
      },
      {
        fill: '#FFF8BC',
        border: {
          color: '#FFF8BC',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '50%',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'OFF',
            size: 30,
            offsetY: 210
          }
        }
      },
      {
        fill: '#FFFFFF',
        border: {
          color: '#FFFFFF',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: 'FREE',
            size: 50,
            offsetY: 260
          },
          sub: {
            text: 'GIFT',
            size: 30,
            offsetY: 210
          }
        }
      }
    ]
  },
  '189': {
    version: '1.0.0',
    size: {
      radius: 370,
      borderWidth: 16,
      centerOffsetX: 0,
      centerOffsetY: 0,
    },
    colors: {
      border: '#BA6513',
      text: '#A25813',
      backgrounds: ['#FFF8BC', '#FFFFFF']
    },
    text: {
      fontFamily: 'Arial, sans-serif'
    },
    slices: [
      {
        fill: '#FFF4E7',
        border: {
          color: '#FFF4E7',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '50%',
            size: 80,
            offsetY: 230
          },
          sub: {
            text: 'OFF',
            size: 50,
            offsetY: 140
          }
        }
      },
      {
        fill: '#FFFCEC',
        border: {
          color: '#FFFCEC',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '15%',
            size: 80,
            offsetY: 230
          },
          sub: {
            text: 'OFF',
            size: 50,
            offsetY: 140
          }
        }
      },
      {
        fill: '#FFFFFF',
        border: {
          color: '#FFFFFF',
          width: 1,
          style: 'solid'
        },
        label: {
          main: {
            text: '10%',
            size: 80,
            offsetY: 230
          },
          sub: {
            text: 'OFF',
            size: 50,
            offsetY: 140
          }
        }
      }
    ]
  }
};
